import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
export default {
  props: {
    prefix: {
      type: String,
      default: 'icon'
    },
    name: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: ''
    },
    size: {
      type: [Number, String],
      default: '1em'
    }
  },
  computed: {
    symbolId: function symbolId() {
      return "#".concat(this.prefix, "-").concat(this.name);
    },
    isVanIcon: function isVanIcon() {
      var regExp = /^van-icon-/;
      return regExp.test(this.name);
    }
  },
  mounted: function mounted() {}
};